"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCustomerOrderSummariesQuery = exports.useGetUserOrdersQuery = exports.ordersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var ordersApi = (0, react_1.createApi)({
    reducerPath: "ordersApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_ORDER_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Order", "CustomerSummary"],
    endpoints: function (builder) { return ({
        getUserOrders: builder.query({
            query: function (args) { return ({ url: "v2/user/order/list", params: args }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : { orders_list: [], count: 0 }; },
            providesTags: function (_result, _error, args) { return [{ type: "Order", id: args.user_id }]; },
        }),
        // the customers list is served by the order service, since each row carries that customer's order summary
        getCustomerOrderSummaries: builder.query({
            query: function (args) { return ({ url: "v2/user/list/order/summary", params: args }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : { user_list: [], count: 0 }; },
            providesTags: ["CustomerSummary"],
        }),
    }); },
});
exports.ordersApi = ordersApi;
var useGetUserOrdersQuery = ordersApi.useGetUserOrdersQuery, useGetCustomerOrderSummariesQuery = ordersApi.useGetCustomerOrderSummariesQuery;
exports.useGetUserOrdersQuery = useGetUserOrdersQuery;
exports.useGetCustomerOrderSummariesQuery = useGetCustomerOrderSummariesQuery;
